import React, { useCallback, useEffect, useMemo, useState } from "react"
import { Button, Col, Dropdown, Form, Row } from "react-bootstrap"
import { useAllReportsContext } from "../../../revised_components/contextProviders/allReportsContext"
import { useLocation } from "react-router-dom";
import { ROLE, USR } from "../../../../shared/Data/typeDirs";
import { toArray } from "../../../../services/networkRequests";
import { useUserContext } from "../../../revised_components/contextProviders/userContext";
import { genId } from "../../../../shared/utils";
import { useControl, useControlReducer } from "../../controlContext";
import { useSource, useSourceReducer } from "../../sourceContext";
import ButtonWithLoadSpinner from "../../../buttonWithLoadSpinner";
import { dataSource } from "../../../../services/dataSource";
import { useNotificationContext } from "../../../revised_components/contextProviders/notificationContext";
import { useSchemaReducer } from "../../schemaContext";


const userSchema = {
  _id: '1',
  name: 'userSchema',
  content: [{
    type: 'Container',
    name: 'root',
    children: [
      {
        name: 'userInfo',
        type: 'Container',
        children: [
          { name: 'username', label: 'Username', type: 'text' },
          { name: 'firstName', type: 'text', label: 'First Name' },
          { name: 'lastName', type: 'text', label: 'Last Name' },
          { name: 'role', label: 'Role', type: 'dropdown', source: 'roles' },
        ]
      },
      {
        name: 'userData',
        type: 'Container',
        children: [
          { name: 'password', label: 'Password', type: 'text' }
        ]
      }
    ]
  }]
}


export function UserHeaderWrapper({settings, setSettings}) {
  const { [USR]: users } = useAllReportsContext()
  const displayNotif = useNotificationContext()
  const controls = useControl()
  const controlReducer = useControlReducer()
  const source = useSource()
  const sourceReducer = useSourceReducer()
  const schemaReducer = useSchemaReducer()
  const [selectedUser, setSelectedUser] = useState()
  const location = useLocation()
  const { user } = useUserContext()
  const init = useCallback(async () => {
    let roles = await toArray(ROLE, user.token)
    console.log('got roles', roles)
    schemaReducer({type: '_init', schemas: [userSchema]})
    sourceReducer({ type: '_init', source: {roles} })
  }, [location])
  const userList = useMemo(() => {
    return [{_id:genId()}, ...users.map(itm => ({ ...itm, schema: 'userSchema', role: source && source[ROLE] && source[ROLE].find(role=>role.name === itm.role)}))]
  }, [users, selectedUser, source])

  const onSelect = useCallback(eventKey => {
    const u = userList.find(itm => eventKey === itm._id)
    setSelectedUser(u)
    setSettings({...settings, readOnly:true})
    controlReducer({ type: 'set_full_controls', controls: [{...u, schema: 'userSchema'}] })
    setTimeout(()=>{
      setSettings({...settings, readOnly:false})
    })
  }, [controlReducer, userList])

  const onSave = useCallback(async ()=>{
    console.log('attempting to save new user', controls)
    let res = await dataSource('remDb')[USR].put(controls[0])
    console.log('saved a new user', res)
    if(!res.message ) return displayNotif('success', 'Saved User!')
    console.warn('Failed saving User', res)
    return displayNotif('danger', `Failed saving User: ${res.message}`, 10000)
  
    })

  useEffect(() => { init() }, [init])

  return (
    <Row className="g-0" style={{backgroundColor:"#ebebeb", border:'1px solid #c9c9c9', padding:'5px', fontWeight:'bold'}}>
      <Col>
      <Row>
        {selectedUser?<Form.Label style={{textAlign:'right'}} column sm="3">Editing User: </Form.Label>:[]}
        <Col>
          <Dropdown onSelect={onSelect}>
            <Dropdown.Toggle variant="info" style={{width:'80%', fontWeight:'bold'}} >
              {selectedUser && selectedUser.username ? selectedUser.username : selectedUser ? '(New User)': 'Select a User'}
            </Dropdown.Toggle>
            <Dropdown.Menu popperConfig={{ strategy: 'fixed' }} renderOnMount={true} align="end">
              {userList.map(
                itm => <Dropdown.Item eventKey={itm._id}>{itm.username || '(New User)'}</Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
      </Col>
      <Col>
        <ButtonWithLoadSpinner style={{fontWeight:'bold'}} variant="activated" onClick={onSave} >Save</ButtonWithLoadSpinner>
      </Col>
    </Row>
  )
}